export default __webpack_public_path__ + "static/media/gift-cart.94789c7d.svg";